import script from "./Level4Confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./Level4Confirm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__